import type { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

type Props = {
  content: string;
};

export function StaffMarkdown({ content }: Props): ReactNode {
  if (!content.trim()) return null;
  return (
    <ReactMarkdown
      components={{
        h1: ({ children }) => <h2 className="mt-3 text-base font-semibold first:mt-0">{children}</h2>,
        h2: ({ children }) => <h3 className="mt-2 text-sm font-semibold">{children}</h3>,
        h3: ({ children }) => <h4 className="mt-2 text-sm font-medium">{children}</h4>,
        a: ({ href, children }) => {
          if (href?.startsWith('/')) {
            return (
              <Link to={href} className="text-[hsl(var(--ui-accent))] underline underline-offset-2">
                {children}
              </Link>
            );
          }
          return (
            <a href={href} className="text-[hsl(var(--ui-accent))] underline underline-offset-2" target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        },
        ul: ({ children }) => <ul className="my-1 list-disc pl-5">{children}</ul>,
        ol: ({ children }) => <ol className="my-1 list-decimal pl-5">{children}</ol>,
        li: ({ children }) => <li className="my-0.5">{children}</li>,
        code: ({ children }) => (
          <code className="rounded-sm bg-[hsl(var(--ui-muted))] px-1 py-0.5 text-sm">{children}</code>
        ),
        img: ({ src, alt }) => (
          <img src={src} alt={alt ?? ''} className="my-2 max-w-full rounded-lg" loading="lazy" />
        ),
        p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
        strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
